<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryReplacementRepairResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="takeAwayMaterial()"
                                    >
                                        扫码取走
                                    </b-button>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="returnMaterial()"
                                    >
                                        扫码返回
                                    </b-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <!-- 扫码框 -->
        <el-dialog title="扫一扫" :center="true" :visible.sync="scannerVisible" @close="closeScannerDialog" :close-on-click-modal='false' append-to-body>
            <qr-code-scanner ref="scanner" @getCodeData='getCodeData'>
            </qr-code-scanner>
        </el-dialog>
        <!-- 取走dialog -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal='false' append-to-body @close="closeOperationDialog">
            <el-table :data="itemList" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column property="poNumber" label="PO"></el-table-column>
                <el-table-column property="itemCode" label="ITEM"></el-table-column>
                <el-table-column property="materielCode" label="物料号"></el-table-column>
                <el-table-column property="materielName" label="物料名称"></el-table-column>
                <el-table-column property="quantity" label="换修数量"></el-table-column>
                <el-table-column label="状态" prop="taskStatus">
                    <template slot-scope="scope">
                        {{replacementStatus(scope.row.taskStatus)}}
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button @click="confirm()">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-08-10 17:35:11

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory"

    export default {
        name: "sithMesInventoryReplacementRepairListView",
        components: { qrCodeScanner },
        mixins: [emCommonListMixin,emCommonApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                // 扫码框是否显示
                scannerVisible: false,
                // 根据POITEM查询出的换修货记录
                itemList: [],
                // 对话框是否显示
                dialogVisible: false,
                // 对话框标题
                dialogTitle: '',
                // 操作类型take--取走，return--返回
                operationType: '',
                currentRow: null
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        },
        methods: {
            handleCurrentChange(val) {
                this.currentRow = val;
            },
            takeAwayMaterial() {
                this.scannerVisible = true;
                this.dialogTitle = '取走';
                this.operationType = 'take';
                setTimeout(() => {
                    this.$refs.scanner.openCamera('');
                },500);
            },
            returnMaterial() {
                this.scannerVisible = true;
                this.dialogTitle = '返回';
                this.operationType = 'return';
                setTimeout(() => {
                    this.$refs.scanner.openCamera('');
                },500);
            },
            replacementStatus(status) {
                if(status) {
                    switch(status) {
                        case 1:
                            return '已创建'
                        case 2:
                            return '已取走'
                        case 3:
                            return '已返回'
                    }
                }
            },
            getCodeData(data) {
                console.log("get qr code data:"+data);
                this.scannerVisible = false;
                let self = this;
                //检验二维码的数据格式
                try {
                    var obj = JSON.parse(data);
                    var poNumber = obj.PO;
                    var item = obj.PoItem;
                    console.log(poNumber);
                    console.log(item);
                } catch (error) {
                    self.$message({
                    message: "无效的二维码",
                    type: "error",
                    });
                    return;
                }

                let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryReplacementRepair")}/`;
                if(self.operationType === 'take') {
                    _url += `findCreatedRepairRecord?poNumber=${poNumber}&item=${item}`
                } else {
                    _url += `findRemovedRepairRecord?poNumber=${poNumber}&item=${item}`
                }
                this.$_emApiMixin_get(_url, {})
                    .then((value) => {
                    // var arr = Object.keys(value);
                    if (value.list.length != 0) {
                        console.log("value======"+JSON.stringify(value));
                        self.itemList = value.list;
                        self.$message({
                        message: "扫码成功",
                        type: "success",
                        });
                        // 扫描成功后打开操作dialog
                        self.dialogVisible = true;
                    } else {
                        self.$message({
                        message: "无换修货记录",
                        type: "error",
                        });
                    }
                    })
                    .finally(() => {
                    this.scannerVisible = false;
                    });
            },
            // 确认取走或返回
            confirm() {
                let self = this;
                let poitemId = self.currentRow.id;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryReplacementRepair")}/`;
                if(this.operationType === 'take') {
                    url += `confirmTakeAway?id=${poitemId}`
                } else {
                    url += `confirmReturn?id=${poitemId}`
                }
                this.$_emApiMixin_post(url, {})
                .then(response => {
                    if(response.status === 200) {
                        self.$message({
                            message: "操作成功",
                            type: "success"
                        })
                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "操作失败",
                            type: "error"
                        })
                    }
                })
                .finally(() => {
                    this.dialogVisible = false;
                });
            },
            // 关闭操作dialog
            closeOperationDialog() {
                this.itemList = [];
                this.dialogTitle = '';
                this.operationType = '';
            },
            // 关闭扫码框
            closeScannerDialog() {
                this.$refs.scanner.closeCamera();
                this.$refs.scanner.resetOutputData();
                this.scannerVisible = false;
            },

        },
    };
</script>

<style scoped>
.el-table__body tr.current-row>td {
    color: #fff;
    background-color: #00FFFF !important;
}
</style>
